import { render, staticRenderFns } from "./ChooseContentConfirm.vue?vue&type=template&id=23673590&"
import script from "./ChooseContentConfirm.vue?vue&type=script&lang=ts&"
export * from "./ChooseContentConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports